<template>
	<div class="scroll-list-container" :class="{top, bottom}">
		<div class="scroll-list-content" ref="content" :style="{'max-height': height}">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	import _ from '@@/lodash';

	export default {
		props: {
			items: {
				type: Number,
				default: 0,
			},
		},

		data() {
			return {
				elements: [],
				observer: null,
				top: false,
				bottom: false,
				height: null,
			};
		},

		computed: {
			content() {
				return this.$refs.content;
			},

			enabled() {
				return this.elements.length > this.items > 0;
			},
		},

		watch: {
			elements() {
				this.update();
			},

			enabled(value) {
				this.setListeners(value);
			},
		},

		methods: {
			getHeight() {
				return _.sum(_.slice(_.sortBy(_.map(this.elements, e => e.offsetHeight)), -this.items));
			},

			update(e = {}) {
				if (this.enabled) {
					this.height = e.type !== 'scroll' ? this.getHeight() + 'px' : this.height;
					this.top = this.content.scrollTop > 0;
					this.bottom = this.content.scrollHeight - this.content.scrollTop > parseInt(this.height);
				} else {
					this.top = false;
					this.bottom = false;
					this.height = null;
				}
			},

			setObserver(set = true) {
				if (set) {
					this.observer = new MutationObserver(_.debounce(() => this.updateElements()));
					this.observer.observe(this.content, {
						attributes: true,
						attributeFilter: ['class'],
						childList: true,
						subtree: true,
					});
				} else if (this.observer instanceof MutationObserver) {
					this.observer.disconnect();
				}
			},

			setListeners(set) {
				if (set) {
					this.content.addEventListener('scroll', this.update);
					window.addEventListener('resize', _.debounce(this.update, 300));
				} else {
					this.content.removeEventListener('scroll', this.update);
					window.removeEventListener('resize', _.debounce(this.update, 300));
				}
			},

			updateElements() {
				this.elements = _.toArray(this.content.children);
			},
		},

		mounted() {
			this.updateElements();
			this.setObserver();
		},

		beforeDestroy() {
			this.setObserver(false);
			this.setListeners(false);
		},
	};
</script>

<style scoped lang="less">
	.scroll-list-container {
		position: relative;

		&.top:before,
		&.bottom:after {
			content: '';
			position: absolute;
			left: 0;
			right: 0;
			width: auto;
			height: 10px;
			z-index: 10;
			pointer-events: none;
			background-repeat: no-repeat;
			background-position: 0 0, 0 0;
			background-size: 100% 1px, 100% 5px;
			background-image: -webkit-gradient(linear, left top, left bottom, from(transparent), to(rgba(0, 0, 0, 0.2))), radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, .4), transparent);
			background-image: -o-linear-gradient(transparent, rgba(0, 0, 0, 0.2)), -o-radial-gradient(50% 0, farthest-side, rgba(0, 0, 0, .4), transparent);
			background-image: linear-gradient(transparent, rgba(0, 0, 0, 0.2)), radial-gradient(farthest-side at 50% 0, rgba(0, 0, 0, .4), transparent);
		}

		&.bottom:after {
			-webkit-transform: rotate(180deg);
			-ms-transform: rotate(180deg);
			transform: rotate(180deg);
			-webkit-transform-origin: top;
			-ms-transform-origin: top;
			transform-origin: top;
		}

		.scroll-list-content {
			overflow-x: hidden;
			overflow-y: auto;
			padding: 0 15px;
			margin: 0 -15px;
			-webkit-overflow-scrolling: touch;
			-webkit-transition: max-height .3s;
			-o-transition: max-height .3s;
			transition: max-height .3s;
		}
	}
</style>
